import { getNavigationType } from '../../utils/get-navigation-type.js';
export const buildViewPageEvent = (inputProperties) => ({
    ...inputProperties,
    object: Promise.resolve(inputProperties.object).then((objectProperties) => {
        const { pageId, ...rest } = objectProperties;
        return {
            ...rest,
            id: pageId,
            navigationType: getNavigationType(),
            type: 'Page',
            url: window.location.href,
        };
    }),
});
//# sourceMappingURL=event-builder.js.map